import { Pipe } from '@angular/core';
var DiffPipe = (function () {
    function DiffPipe() {
    }
    DiffPipe.prototype.transform = function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!Array.isArray(input)) {
            return input;
        }
        return args.reduce(function (d, c) { return d.filter(function (e) { return !~c.indexOf(e); }); }, input);
    };
    return DiffPipe;
}());
export { DiffPipe };
DiffPipe.decorators = [
    { type: Pipe, args: [{ name: 'diff' },] },
];
/** @nocollapse */
DiffPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=diff.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/diff.js
// module id = 198
// module chunks = 4